// src/pages/CourseTime/components/slides/layouts/SessionStartSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';

// Layout: TemplateSessionStart
const SessionStartSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => (
  <S.SlideWithImage>
    <S.SlideTitleMobile> <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} /></S.SlideTitleMobile>
    {slide.Images && slide.Images.length > 0 && (
      <S.SlideTopImageContainer>
        <S.SlideImage
          src={typeof slide.Images[0] === 'string' ? slide.Images[0] : slide.Images[0].url || ''}
          alt={`Slide ${slide.SlideOrder} image`}
        />
      </S.SlideTopImageContainer>
    )}
    <S.SlideTitleContainer>
      <S.SlidePoint>
        <S.SlideTitle className="mobile-hidden">
          <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
        </S.SlideTitle>
      </S.SlidePoint>
    </S.SlideTitleContainer>
  </S.SlideWithImage>
);

export default SessionStartSlide;
